export default __webpack_public_path__ + "images/7613e6908514413f8bb222c65ff15006.png";